import Select from "antd/es/select";
import TimePicker from "antd/es/time-picker";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { DateInput } from "semantic-ui-calendar-react";
import { Button } from "semantic-ui-react";
import "../../assets/style/global-leave.scss";
import functionCommon from "../../core/common/function";
import { commonConstants } from "../../core/constant/common.constants";
import "./style.scss";

const WorkflowForm = (props) => {
    const { t } = useTranslation();
    const history = useHistory();
    const {
        sendData,
        isError,
        handleSubmit,
        changeLeaveType,
        changeManagetLeader,
        changeRequestTime,
        leaveType,
        availableTime,
        listManagerLeader,
        listEmployee,
        isSubmitting,
        roundTowDecimal,
        roundHalf,
        changeDatePicker,
        sendDataWorkLog,
        message,
        changeRequestFor,
        listDay,
        setListDay,
    } = props;
    const { Option } = Select;
    const employeeId = functionCommon.getInfoUser("employeeId");
    const employeeName = functionCommon.getInfoUser("employeeName");
    const [date, setDate] = useState({
        dateFrom: moment().format("DD-MM-YYYY"),
        dateTo: moment().format("DD-MM-YYYY"),
    });
    const [timeLeave, setTimeLeave] = useState({
        timeFrom: moment(commonConstants.TIME_START, "HH:mm"),
        timeTo: moment(commonConstants.TIME_END, "HH:mm"),
    });
    const [dataRequest, setDataRequest] = useState({
        requestedForId: "",
        managerLeaderId: "",
        projectManagerId: [],
        leaveTypeId: "",
        dayFrom: date.dateFrom,
        dayTo: date.dateTo,
        timeFrom: timeLeave.timeFrom._i,
        timeTo: timeLeave.timeTo._i,
        requestTimeOff: "",
        leaveReason: "",
        comment: "",
        radio: "day",
    });
    const [day, setDay] = useState(0);
    const [inputList, setInputList] = useState([{ day: "", hours: "" }]);
    const minuteStep = commonConstants.MINUTE_STEP;

    const handleChangeRequestFor = (value) => {
        if (!value) {
            setDataRequest({ ...dataRequest, requestedForId: employeeId });
            changeRequestFor(value);
        } else {
            setDataRequest({ ...dataRequest, requestedForId: Number(value) });
            changeRequestFor(value);
        }
    };

    const handleChangeManagerLeader = (value) => {
        changeManagetLeader();
        if (!value) {
            setDataRequest({ ...dataRequest, managerLeaderId: "" });
        } else {
            setDataRequest({ ...dataRequest, managerLeaderId: Number(value) });
        }
    };

    const handleChangeProjectManager = (value) => {
        setDataRequest({ ...dataRequest, projectManagerId: value });
    };

    const handelBlur = (e) => {
        const number = Number(e.target.value);
        const maxRequestTime = commonConstants.NUMBER_DAY_IN_YEAR;
        const minRequestTime = commonConstants.MIN_REQUEST_TIME;
        const leaveTypeId = dataRequest.leaveTypeId;
        if (dataRequest.radio === commonConstants.VALUE_RADIO_DAY) {
            if (leaveTypeId === commonConstants.SPECIAL_LEAVE_TYPE) {
                if (!isNaN(number) && number <= maxRequestTime && number >= minRequestTime) {
                    const _requestTime = roundTowDecimal(number);
                    const requestTime = parseFloat(Number(_requestTime));
                    setDataRequest({
                        ...dataRequest,
                        requestTimeOff: String(requestTime),
                    });
                } else {
                    const requestTime = "";
                    setDataRequest({ ...dataRequest, requestTimeOff: String(requestTime) });
                }
            } else {
                if (number === "") {
                    const requestTime = "";
                    setDataRequest({ ...dataRequest, requestTimeOff: String(requestTime) });
                } else {
                    if (!isNaN(number) && number <= maxRequestTime && number >= minRequestTime) {
                        const _requestTime = roundHalf(number);
                        const requestTime = parseFloat(Number(_requestTime));
                        setDataRequest({ ...dataRequest, requestTimeOff: String(requestTime) });
                    } else {
                        const requestTime = "";
                        setDataRequest({ ...dataRequest, requestTimeOff: String(requestTime) });
                    }
                }
            }
        } else {
            const value = Number(number);
            if (number === "") {
                const requestTime = "";
                setDataRequest({ ...dataRequest, requestTimeOff: String(requestTime) });
            } else {
                if (!isNaN(value) && value >= minRequestTime) {
                    const requestTime = parseFloat(value);
                    setDataRequest({ ...dataRequest, requestTimeOff: String(requestTime) });
                } else {
                    const requestTime = "";
                    setDataRequest({ ...dataRequest, requestTimeOff: String(requestTime) });
                }
            }
        }
    };

    const handleChangeLeaveType = (value) => {
        setDataRequest({
            ...dataRequest,
            leaveTypeId: Number(value),
            requestTimeOff: "",
        });
        changeLeaveType(Number(value));
    };

    const handleChangeNewRequest = (e) => {
        const { value, name } = e.target;
        if (!value) {
            setDataRequest({ ...dataRequest, [name]: "" });
        } else {
            setDataRequest({ ...dataRequest, [name]: value });
        }
    };

    const handleChangeRadio = (e) => {
        changeRequestTime();
        const { value } = e.target;
        if (!value) {
            setDataRequest({ ...dataRequest, radio: "" });
        } else {
            setDataRequest({ ...dataRequest, radio: value, requestTimeOff: "" });
        }
    };

    const handleChangeRequestTime = (e) => {
        changeRequestTime();
        const value = functionCommon.onInputNumberPositive(e, true);
        const maxRequestTime = commonConstants.NUMBER_DAY_IN_YEAR;
        if (dataRequest.radio === commonConstants.VALUE_RADIO_DAY) {
            if (Number(value) <= maxRequestTime && Number(value) >= 0) {
                setDataRequest({ ...dataRequest, requestTimeOff: value });
            } else {
                const requestTime = String(value).slice(0, value.length - 1);
                setDataRequest({ ...dataRequest, requestTimeOff: requestTime });
            }
        } else {
            const isValidDigit =
                String(value).indexOf(".") < 0 ||
                (String(value).indexOf(".") >= 0 && String(value).split(".")[1].length <= 2);
            if (Number(value) >= 0 && isValidDigit) {
                setDataRequest({ ...dataRequest, requestTimeOff: value });
            } else {
                const requestTime = String(value).slice(0, value.length - 1);
                setDataRequest({ ...dataRequest, requestTimeOff: requestTime });
            }
        }
    };

    const handleChangeDateFrom = (e, data) => {
        setDate({ ...date, dateFrom: data.value });
        setDataRequest({
            ...dataRequest,
            dayFrom: data.value,
        });
        changeDatePicker();
    };

    const handleChangeDateTo = (e, data) => {
        setDate({ ...date, dateTo: data.value });
        setDataRequest({
            ...dataRequest,
            dayTo: data.value,
        });
        changeDatePicker();
    };

    const handleChangeTimeFrom = (time, timeString) => {
        setTimeLeave({ ...timeLeave, timeFrom: timeString });
        setDataRequest({
            ...dataRequest,
            timeFrom: timeString,
        });
    };

    const handleChangeTimeTo = (time, timeString) => {
        setTimeLeave({ ...timeLeave, timeTo: timeString });
        setDataRequest({
            ...dataRequest,
            timeTo: timeString,
        });
    };

    const handleBack = () => {
        history.push("/my-leave-request");
    };

    const onKeyDown = (event) => {
        functionCommon.onKeyDownNumber(event, true);
    };

    const handleChangeHourInput = (index) => (event) => {
        const max = commonConstants.WORK_TIME;
        const { value, name } = event.target;
        const list = [...listDay];
        if (Number(value) <= max && Number(value) >= 0) {
            list[index].value.hours = value;
            list[index].isError = false;
            setListDay(list);
        } else if (value === "") {
            list[index].value.hours = "";
            setListDay(list);
        }
    };

    const handleBlurHourInput = (index) => (event) => {
        const { value, name } = event.target;
        const list = [...listDay];
        if (Number(value) % 1 !== 0) {
            list[index].value.hours = String(parseFloat(roundTowDecimal(value)));
            list[index].isError = false;
            setListDay(list);
        } else if (value === "") {
            list[index].value.hours = "";
            setListDay(list);
        } else if (Number(value) === 0) {
            list[index].value.hours = "";
            setListDay(list);
        } else {
            list[index].value.hours = String(parseFloat(value));
            setListDay(list);
        }
    };

    const handleChangeHourInputWeekend = (index) => (event) => {
        const max = commonConstants.WORK_TIME;
        const { value, name } = event.target;
        const list = [...listDay];
        if (Number(value) <= max && Number(value) >= 0) {
            list[index].value.hours = value;
            list[index].isError = false;
            setListDay(list);
        } else if (value === "") {
            list[index].value.hours = "";
            setListDay(list);
        }
    };

    const handleBlurHourInputWeekend = (index) => (event) => {
        const { value, name } = event.target;
        const list = [...listDay];
        if (Number(value) % 1 !== 0) {
            list[index].value.hours = String(parseFloat(roundTowDecimal(value)));
            list[index].isError = false;
            setListDay(list);
        } else if (value === "") {
            list[index].value.hours = "";
            setListDay(list);
        } else {
            list[index].value.hours = String(parseFloat(value));
            setListDay(list);
        }
    };


    useEffect(() => {
        const sumDay = () => {
            const _dayFrom = moment(dataRequest.dayFrom, "DD/MM/YYYY").format("YYYY-MM-DD");
            const dayFrom = new Date(_dayFrom);
            const _dayTo = moment(dataRequest.dayTo, "DD/MM/YYYY").format("YYYY-MM-DD");
            const dayTo = new Date(_dayTo);
            const moreMonth = (dayTo.getTime() - dayFrom.getTime()) / 1000 / 60 / 60 / 24;
            setDay(moreMonth);
            let listDate = [];
            let day;
            for (let d = dayFrom; d <= dayTo; d.setDate(d.getDate() + 1)) {
                const date = moment(d, "DD/MM/YY").format("YYYY-MM-DD");
                if (moment(date).isoWeekday() === 6 || moment(date).isoWeekday() === 7) {
                    day = {
                        day: new Date(d),
                        value: { day: date, hours: "0" },
                    };
                } else {
                    day = {
                        day: new Date(d),
                        value: { day: date, hours: "" },
                    };
                }
                listDate.push(day);
            }
            setListDay(listDate);
        };

        sumDay();
    }, [dataRequest.dayFrom, dataRequest.dayTo]);

    useEffect(() => {
        const input = [];
        const setValueField = () => {
            for (let i = 1; i <= listDay.length; i++) {
                input.push({ day: moment(listDay[i - 1]).format("YYYY-MM-DD"), hours: "" });
            }
            setInputList(input);
        };
        setValueField();
    }, [listDay]);

    useEffect(() => {
        sendData(dataRequest);
        if (day > commonConstants.NUMBER_DAY_IN_MONTH) {
            const data = [];
            sendDataWorkLog(data);
        } else {
            sendDataWorkLog(listDay);
        }
    }, [inputList, dataRequest, day]);

    const elementText = listDay.map((item, index) => {
        return (
            <div className="wrapper" key={index}>
                {moment(item.day).isoWeekday() === 6 || moment(item.day).isoWeekday() === 7 ? (
                    <div className="wrapper-input">
                        <p className="weekend">
                            {moment(item.day)
                                .locale(localStorage.getItem("i18nextLng") === "en" ? "en" : "vi")
                                .format("ddd, DD/MM/YYYY")}
                        </p>
                        <input
                            onBlur={handleBlurHourInputWeekend(index)}
                            name="hours"
                            onKeyDown={onKeyDown}
                            onPaste={functionCommon.onPasteNumber}
                            type={"number"}
                            className={item.isError ? "border-red" : "input-hour"}
                            value={item.value.hours}
                            onChange={handleChangeHourInputWeekend(index)}
                        />
                    </div>
                ) : (
                    <>
                        <div className="wrapper-input">
                            <p className="week">
                                {moment(item.day)
                                    .locale(localStorage.getItem("i18nextLng") === "en" ? "en" : "vi")
                                    .format("ddd, DD/MM/YYYY")}
                            </p>
                            <input
                                required
                                onBlur={handleBlurHourInput(index)}
                                name="hours"
                                onKeyDown={onKeyDown}
                                onPaste={functionCommon.onPasteNumber}
                                type={"number"}
                                className={item.isError ? "border-red" : "input-hour"}
                                value={item.value.hours}
                                onChange={handleChangeHourInput(index)}
                            />
                        </div>
                    </>
                )}
            </div>
        );
    });


    return (
        <div className="new-leave-request">
            <h4 className="leave-title">{t("button.newLeaveRequest")}</h4>
            <div className="leave-workflow-form">
                <h4 className="leave-workflow-form-title">{t("labels.workflowInformation")}</h4>
                <div className="leave-workflow-form-content">
                    <div className="form-group">
                        <label className="label">{t("labels.requestedBy")}:</label>
                        <label className="label">{employeeName}</label>
                    </div>
                    <div className="form-group">
                        <label className="label">{t("labels.requestedFor")}:</label>
                        <div className="ui input">
                            <Select
                                className="requested-select input-control"
                                name="requestedForId"
                                fieldNames="requestedForId"
                                showSearch
                                showArrow
                                allowClear
                                filterOption={functionCommon.filterEmployee}
                                style={{ width: 350, height: 29 }}
                                onChange={handleChangeRequestFor}
                            >
                                {listEmployee
                                    ? listEmployee.map((item, index) => {
                                          return (
                                              <Option
                                                  value={item.value}
                                                  label={item.name}
                                                  key={item.value}
                                              >
                                                  {item.name}
                                              </Option>
                                          );
                                      })
                                    : ""}
                            </Select>
                        </div>
                    </div>
                    <div className="form-group from-required">
                        <label className="label line-height">
                            {t("labels.managerLeader")}: <span className="required">*</span>
                        </label>
                        <div className="ui input">
                            <Select
                                className="managerLeader-select input-control"
                                name="managerLeaderId"
                                allowClear
                                showSearch
                                filterOption={functionCommon.filterEmployee}
                                style={{ width: 350, height: 29 }}
                                onChange={handleChangeManagerLeader}
                            >
                                {listManagerLeader
                                    ? listManagerLeader.map((item, index) => {
                                          return (
                                              <Option
                                                  value={item.value}
                                                  label={item.name}
                                                  key={item.value}
                                              >
                                                  {item.name}
                                              </Option>
                                          );
                                      })
                                    : ""}
                            </Select>
                        </div>
                    </div>
                    <div className="form-group ">
                        <label className="label"></label>
                        <div className="ui input">
                            <p className="error-message error">{t(isError["managerLeaderId"])}</p>
                        </div>
                    </div>
                    <div className="form-group">
                        <label className="label">{t("labels.ccList")}:</label>
                        <div className="ui input">
                            <Select
                                className="project-select input-control"
                                name="projectManagerId"
                                mode="multiple"
                                allowClear
                                showArrow
                                showSearch
                                maxTagCount={2}
                                onChange={handleChangeProjectManager}
                                filterOption={functionCommon.filterEmployee}
                                style={{ width: 350, height: 29 }}
                            >
                                {listEmployee &&
                                    listEmployee.map((item, index) => {
                                        return (
                                            <Option
                                                value={item.value}
                                                label={item.name}
                                                key={item.value}
                                            >
                                                {item.name}
                                            </Option>
                                        );
                                    })}
                            </Select>
                        </div>
                    </div>
                </div>
            </div>
            {message && <div className="error-message list-error-message">{message}</div>}
            <div className="leave-request-form">
                <h4 className="leave-request-form-title">{t("labels.leaveRequestInformation")}</h4>
                <div className="leave-request-form-content">
                    <div className="form-group">
                        <div className="form-left">
                            <p className="text">
                                {t("labels.leaveTypeChose")}: <span className="required">*</span>
                            </p>
                        </div>
                        <div className="form-right">
                            <div className="form-input">
                                <Select
                                    className="select-leavetype input-control"
                                    name="leaveTypeId"
                                    value={dataRequest.leaveTypeId}
                                    style={{ width: 350, height: 29 }}
                                    onChange={handleChangeLeaveType}
                                >
                                    {leaveType
                                        ? leaveType.map((item, index) => {
                                              return (
                                                  <Option
                                                      value={item.leaveTypeId}
                                                      label={item.leaveTypeName}
                                                      key={item.leaveTypeId}
                                                  >
                                                      {item.leaveTypeName}
                                                  </Option>
                                              );
                                          })
                                        : ""}
                                </Select>
                                <p className="error-message error">{t(isError["leaveTypeId"])}</p>
                            </div>
                        </div>
                    </div>
                    <div className="form-group">
                        <div className="form-left">
                            <p className="text">{t("labels.availableTime")}:</p>
                        </div>
                        <div className="form-right">
                            <div className="form-input p-0">
                                <p className="text">{availableTime.availableTime || 0}</p>
                            </div>
                            <div className="remaining-wapper">
                                <div className="remaining-left">
                                    <p className="text">{t("labels.remainingTimeUntil")}:</p>
                                </div>
                                <div className="remaining-right">
                                    <div className="form-input p-0">
                                        <p className="text">{availableTime.remainingTime || 0}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="form-group">
                        <div className="form-left">
                            <p className="text">{t("labels.leaveFromDate")}:</p>
                        </div>
                        <div className="form-right">
                            <div className="form-input">
                                <DateInput
                                    name="dayFrom"
                                    className="input-date leave-date-picker leave-date-input-restrict"
                                    dateFormat="DD-MM-YYYY"
                                    animation="none"
                                    onChange={handleChangeDateFrom}
                                    value={date.dateFrom}
                                    closable={true}
                                    localization={localStorage.getItem("i18nextLng") === "en" ? "en" : "vi"}
                                    closeOnMouseLeave={false}
                                    hideMobileKeyboard={true}
                                    autoComplete="off"
                                    maxLength="0"
                                    onKeyDown={functionCommon.onKeyDownDateInput}
                                    onMouseEnter={functionCommon.onMouseEnterDateInput}
                                    onMouseLeave={functionCommon.onMouseLeaveDateInput}
                                ></DateInput>
                                <p className="error-message error">{t(isError["dateError"])}</p>
                            </div>
                            <div className="remaining-wapper">
                                <div className="remaining-left">
                                    <p className="text">{t("labels.leaveToDate")}:</p>
                                </div>
                                <div className="remaining-right">
                                    <div className="form-input">
                                        <DateInput
                                            name="dayTo"
                                            className="input-date leave-date-picker leave-date-input-restrict"
                                            dateFormat="DD-MM-YYYY"
                                            animation="none"
                                            onChange={handleChangeDateTo}
                                            value={date.dateTo}
                                            closable={true}
                                            localization={localStorage.getItem("i18nextLng") === "en" ? "en" : "vi"}
                                            closeOnMouseLeave={false}
                                            hideMobileKeyboard={true}
                                            autoComplete="off"
                                            maxLength="0"
                                            onKeyDown={functionCommon.onKeyDownDateInput}
                                            onMouseEnter={functionCommon.onMouseEnterDateInput}
                                            onMouseLeave={functionCommon.onMouseLeaveDateInput}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="form-group">
                        <div className="form-left">
                            <p className="text">{t("labels.leaveFromTime")}:</p>
                        </div>
                        <div className="form-right">
                            <div className="form-input">
                                <TimePicker
                                    name="timeFrom"
                                    className="business-from-input input-time"
                                    inputReadOnly={true}
                                    allowClear={false}
                                    format="HH:mm"
                                    minuteStep={minuteStep}
                                    defaultValue={timeLeave.timeFrom}
                                    onChange={handleChangeTimeFrom}
                                />
                            </div>
                            <div className="remaining-wapper">
                                <div className="remaining-left">
                                    <p className="text">{t("labels.leaveToTime")}:</p>
                                </div>
                                <div className="remaining-right">
                                    <div className="form-input">
                                        <TimePicker
                                            name="timeTo"
                                            className="business-from-input input-time"
                                            inputReadOnly={true}
                                            format="HH:mm"
                                            minuteStep={minuteStep}
                                            allowClear={false}
                                            defaultValue={timeLeave.timeTo}
                                            onChange={handleChangeTimeTo}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="form-group">
                        <div className="form-left">
                            <p className="text">
                                {t("labels.requestedTimeOff")}: <span className="required">*</span>
                            </p>
                        </div>
                        <div className="form-right">
                            <div className="form-input input-timeoff">
                                <input
                                    name="requestTimeOff"
                                    className="input-requestdate"
                                    onChange={handleChangeRequestTime}
                                    type={"text"}
                                    value={dataRequest.requestTimeOff}
                                    onBlur={handelBlur}
                                    onKeyDown={onKeyDown}
                                    onPaste={functionCommon.onPasteNumber}
                                />
                                <label className="radio">
                                    <label className="radio-day">
                                        <span>{t("labels.days")}</span>
                                        <input
                                            type={"radio"}
                                            name="radio"
                                            value="day"
                                            defaultChecked={true}
                                            onChange={handleChangeRadio}
                                        />
                                    </label>
                                    <label className="radio-hour">
                                        <span>{t("labels.hours")}</span>
                                        <input type={"radio"} name="radio" value="hour" onChange={handleChangeRadio} />
                                    </label>
                                </label>

                                <p className="error-message error">{t(isError["requestTimeOff"])}</p>
                            </div>
                        </div>
                    </div>
                    <div className="form-group form-group-textarea">
                        <div className="form-left">
                            <p className="text">{t("labels.leaveReason")}:</p>
                        </div>
                        <div className="form-right">
                            <div className="form-input">
                                <textarea
                                    name="leaveReason"
                                    onChange={handleChangeNewRequest}
                                    maxLength={250}
                                    rows={2}
                                    className="textarea form-item"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="form-group form-group-textarea">
                        <div className="form-left">
                            <p className="text">{t("labels.comment")}:</p>
                        </div>
                        <div className="form-right">
                            <div className="form-input">
                                <textarea
                                    name="comment"
                                    onChange={handleChangeNewRequest}
                                    maxLength={250}
                                    rows={2}
                                    className="textarea form-item"
                                />
                            </div>
                        </div>
                    </div>
                    {day < commonConstants.NUMBER_DAY_IN_MONTH ? (
                        <>
                            {listDay.length > 0 ? (
                                <div className="form-group form-group-textarea ">
                                    <div className="form-left">
                                        <p className="text">{t("labels.forLogWorkCreate")}:</p>
                                    </div>
                                    <div className="form-right for-logwork ">
                                        <div className="form-input list-week">
                                            {elementText}
                                            <p className="error-message error">{t(isError["hoursWorkLog"])}</p>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                ""
                            )}
                        </>
                    ) : (
                        ""
                    )}

                </div>
            </div>
            <div className="button">
                <Button className="leave-button" onClick={handleSubmit} disabled={isSubmitting}>
                    {isSubmitting ? t("button.submitting") : t("button.submit")}
                </Button>
                <Button onClick={handleBack} disabled={isSubmitting}>
                    {t("button.cancel")}
                </Button>
            </div>
        </div>
    );
};

export default WorkflowForm;
